var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "logo-cnt" }, [
    _c("img", { staticClass: "logo", attrs: { src: _vm.logo, alt: "" } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }